import baseState from './baseState';
import tuner from '../tuner';
import listenTimeLogger from '../loggers/listenTime';
import debug from '../debugger';

export function onPlay() {
  listenTimeLogger.setReportStartTime();
  tuner.changeState(tuner.states.playing);
}

export function buildErrorLog(error) {
  return {
    message: error.message,
    context: {
      error,
      streamId: tuner.streamPlayer.getCurrentStreamId(),
    },
  };
}

var state = {
  name: 'failed',
  enter: function (previousState, error = {}) {
    tuner.boostState.introCount = 0;
    tuner.boostState.outroCount = 0;
    debug.log('error', error);
    listenTimeLogger.stopPeriodicLogger();
    tuner.trigger(tuner.events.stationFailed, error.failedWithHttp);
    tuner.trigger(
      tuner.events.error,
      error instanceof Error ? buildErrorLog(error) : error,
    );

    tuner.streamPlayer.on(tuner.streamPlayer.events.play, onPlay);
    // streamPlayer sometimes doesnt fire a play event when a stream resumes
    tuner.streamPlayer.on(tuner.streamPlayer.events.buffer, onPlay);
  },
  exit: function () {
    tuner.streamPlayer.remove(tuner.streamPlayer.events.play, onPlay);
    tuner.streamPlayer.remove(tuner.streamPlayer.events.buffer, onPlay);
  },
};

export default {
  ...baseState,
  ...state,
};
